import type { FaireProductEntity } from "../../entity_types/product";

export const p_xw46z5tnsr: FaireProductEntity = {
  token: "p_xw46z5tnsr",
  type: "product",
  name: "Scolecite Sphere with Deep Vibrations",
  brandToken: "b_en1yij2pf6",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/22e0c0ec11319081ed956287762b2f03568c9dddd6dd7d964ee91838ca801c7a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/495445d655387c7eb55ad6c7c58eb5033080a213b0ad269bd401ba4d7fda691f.jpeg",
    "https://cdn.faire.com/fastly/7923947bbdc50c01c9856fa4f7a77cfe366cc1d83e0e5553eadc1eade293d870.jpeg",
    "https://cdn.faire.com/fastly/316865cde9e7a10dbab8f4808f7a7620442effa3ef9b46a9bd00896b31e5a730.jpeg",
    "https://cdn.faire.com/fastly/8494d56c90d9200eb09e5acaeb8ffc8566a5f5c4b5f61163580fb3b308018521.jpeg",
    "https://cdn.faire.com/fastly/38f73a46f86c5ba991eafe17c1d5f5948e579307dbf31a9dfced86f8ba9f04e1.jpeg",
    "https://cdn.faire.com/fastly/a3eb18b6ece91ce63327f7538f2ae615ec78b89ab34478e69acbc71f9eb23745.jpeg"
  ],
  priceDollars: 23.56,
  description: "The Scolecite, known as Light worker's stone, has powerful vibrations. The Scolecite Spheres are a great tool for an energy healer, reiki master or caregiver of any kind. In the shape of a Sphere, Scolecite radiates peaceful energies in all four directions that help in keeping a clear channel with the Divine to enhance meditations, achieve inner peace and relaxation, bring clarity of mind, promote restful sleep, and empower sweeter dreams. A beautiful piece that can be used artistically to complement decor in any space. \n\nSizes:\nSmall - 0.25-0.30 lbs; approx. 3.50-4 cm\nMedium - 0.35-0.40 lbs; approx. 4.50-5 cm\nLarge - 0.45-0.50 lbs; approx. 5.5-6 cm\n\nSold: Per Piece\nMade in India",
  tags: [],
  msrpDollars: 47.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:53.728Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
